import { Exception } from '../Exception'

export class AuthenticationException extends Exception {
  message = 'Authentication failed'
}
